<!--
 * @Author: zjw
 * @Date: 2021-05-27 11:12:20
 * @LastEditTime: 2023-05-29 16:42:06
 * @FilePath: \web-app\src\components\content\myDialog.vue
 * @Environment: Vue + Element
 * @Description: 添加、修改组件
-->
<template>
    <div>
        <el-dialog
            :close-on-click-modal="false"
            :width="dialogWidth"
            :title="operTitle ? '添加' : '编辑'"
            :visible="isDialogShow"
            @close="closeDialog"
        >
            <!--  label-width="120px"  label-position="left"-->
            <el-form
                ref="operForm"
                :model="operForm"
                :rules="rules"
                size="small"
            >
                <!-- 文本框添加 -->
                <el-form-item
                    v-for="(item, index) in operFormArr"
                    :key="index"
                    :label="item.label"
                    :prop="item.name"
                >
                    <!--  :disabled="item.disabled" -->
                    <el-input
                        v-model="operForm[item.name]"
                        :type="item.type || 'text'"
                        :placeholder="item.defaultText"
                        :disabled="item.disabled"
                        :readonly="item.readonly"
                        autosize
                    ></el-input>
                </el-form-item>
                <!-- 下拉添加 -->
                <el-form-item
                    v-show="selectArrAdd.length != 0"
                    v-for="(option, index) in selectArrAdd"
                    :key="index + Math.random()"
                    :label="option.label"
                    :prop="option.prop"
                >
                    <el-select
                        v-model="operForm[option.prop]"
                        placeholder="请选择"
                        clearable
						size="small"
						@change="getCurrent"
                        :disabled="option.disabled"
                    >
                        <el-option
                            v-for="(item, index) in option.defaultOptions"
                            :key="index + Math.random()"
                            :label="option.optionLabel?item[option.optionLabel]:item.label"
                            :value="
                                option.getData ? item[option.getData] : item
                            "
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <slot name="upload"></slot>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button
                    class="title"
                    size="small"
                    type="primary"
                    :loading="loading"
                    @click="submitForm('operForm')"
                >
                    保存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "myDialog",
    props: {
        // 弹框宽度
        dialogWidth: {
            type: String,
            default: function () {
                return "500px";
            },
        },
        // 控制弹框显示、隐藏
        isDialogShow: {
            type: Boolean,
            default: false,
        },
        /**
         * 弹框标题
         * @param {*} true 为添加
         * @param {*} false 为编辑
         */
        operTitle: {
            type: Boolean,
            default: true,
        },
        /**
         * 添加、修改的双向绑定属性名
         * @param {*} id 必须传，其他属性名再根据页面不同传
         */
        operForm: {
            type: Object,
            default: function () {
                return {};
            },
        },
        /**
         * 文本框需要的参数(支持单行、多行文本)
         * @param {*} name 用来匹配prop值
         * @param {*} label 文本框关联的label文字
         * @param {*} type input文本框类型，默认为text
         * @param {*} defaultText 默认提示文字
         */
        operFormArr: {
            type: Array,
            default: function () {
                return [];
            },
        },
        /**
         * 下拉框需要的参数
         * @param {*} name  用来匹配prop值
         * @param {*} label  用于显示label标题
         * @param {*} getData  用于选择获取label还是获取value，自行选择
         * @param {*} defaultOptions  下拉默认选项
         */
        selectArrAdd: {
            type: Array,
            default: function () {
                return [];
            },
        },
        //验证规则
        rules: {
            type: Object,
            default: function () {
                return {};
            },
        },
        // 加载状态
        loading: {
            type: Boolean,
            default: false,
        },
    },
    created() {
        // this.$bus.$on("clear", () => {
        //   this.$refs[operForm].resetFields();
        // });
    },
    methods: {
        //验证数据并发送事件
        submitForm(data) {
            this.$refs[data].validate((valid) => {
                this.$emit("submitForm", { valid, operTitle: this.operTitle });
            });
        },
        //关闭弹框
        closeDialog() {
            this.$emit("closeDialog", false);
            this.$emit("update:isDialogShow", false); //$emit(‘update:foo‘)子组件同步更新父组件
            // 清除表单验证
            this.$refs.operForm.resetFields();
        },
        //获取选中的下拉
        getCurrent(val) {
            this.$emit("getCurrent", val);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
    padding: 10px 20px;
}
::v-deep .el-form-item {
    margin-bottom: 5px;
}
.el-select {
    width: 100%;
}
</style>

